import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type { Shipment } from 'graphql-models';
import shipmentQuery from 'walden-trace-app/graphql/shipments/shipment.graphql';
import type ApiService from 'walden-trace-app/services/api';

type Resolved<P> = P extends Promise<infer T> ? T : P;
export type AppShipmentsDetailModel = Resolved<ReturnType<AppShipmentsDetailRoute['model']>>;

export default class AppShipmentsDetailRoute extends Route {
  @service('api') declare apiService: ApiService;

  async model(params: { shipment_id: string }) {
    const { shipmentById } = await this.apiService.query<{
      shipmentById: Shipment;
    }>({
      query: shipmentQuery,
      variables: { id: params.shipment_id },
    });

    if (!shipmentById) {
      throw new Error('Shipment not found');
    }

    return { shipment: shipmentById };
  }
}
